import { useLpkRunContext } from './lpk-run-context';
import { InputsHeader } from '../../../run-rx/InputsHeader';
import { Section } from './Section';
import { YieldManualEntry } from './YieldManualEntry';
import { YieldQuickFill } from './YieldQuickFill';

export function YieldSection() {
  const { selectedNutrients } = useLpkRunContext();

  return selectedNutrients.phosphorus || selectedNutrients.potassium ? (
    <Section>
      <InputsHeader
        title="Yield History to Estimate P and K Removal"
        subtitle="Select Type of Drawdown"
        sx={{ mb: -1, '& p:first-of-type': { mb: 1 } }}
      />
      <YieldQuickFill />
      <YieldManualEntry />
    </Section>
  ) : null;
}
